import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  addPatientLoading: false,
  patients: [],
  allPatients: [],
  // Active AND discharged (active: false) clients — reporting only, so a
  // discharged client's historical notes still show up in reports (OD-1294).
  // Never use this list to pick a client for NEW data; use allPatients.
  allReportClients: [],
  allAssignPatients: [],
  activePatientsCount: 0
};

export const patientState = createSlice({
  name: "patients",
  initialState,
  reducers: {
    setLoading(state, action) {
      return {
        ...state,
        loading: action?.payload
      };
    },
    setAddPatientLoading(state, action) {
      return {
        ...state,
        addPatientLoading: action?.payload
      };
    },
    setPatients(state, action) {
      return {
        ...state,
        loading: false,
        patients: action?.payload
      };
    },
    setAllPatients(state, action) {
      return {
        ...state,
        loading: false,
        allPatients: action?.payload
      };
    },

    setAllReportClients(state, action) {
      return {
        ...state,
        allReportClients: action?.payload
      };
    },
    setAllAssignPatients(state, action) {
      return {
        ...state,
        loading: false,
        allAssignPatients: action?.payload
      };
    },
    setActivePatientsCount(state, action) {
      return {
        ...state,
        activePatientsCount: action?.payload
      };
    },
    // Reset State
    reset() {
      return initialState;
    }
  }
});

export const {
  setLoading,
  setAddPatientLoading,
  setPatients,
  setAllPatients,
  setAllReportClients,
  setAllAssignPatients,
  setActivePatientsCount
} = patientState.actions;
export default patientState.reducer;
